export function buildValidationToast(errors: Record<string, string>): string {
  const parts: string[] = [];
  if (errors.title) parts.push('Title is required');

  const stageErrors = Object.entries(errors).filter(([k]) => k.startsWith('stages.'));
  for (const [, message] of stageErrors) {
    parts.push(message);
  }

  return parts.join('; ') || 'Please fix the errors before saving';
}
